<app-offcanvas-sheet
  [visible]="visible"
  [title]="title"
  saveLabel="Save BOM"
  (closeCanvas)="onClose()"
  (save)="onSave()">

  <!-- Product -->
  <div class="form-group-mobile">
    <label>Product</label>
    <app-single-select-dropdown
      [options]="productOptions"
      [selectedValue]="formData.finishedGoodItemID != null ? formData.finishedGoodItemID.toString() : null"
      [disabled]="isEditing"
      placeholder="Select product"
      (selectedValueChange)="formData.finishedGoodItemID = $event != null ? +$event : null">
    </app-single-select-dropdown>
  </div>

  <!-- Active toggle -->
  <div class="form-group-mobile form-group-toggle">
    <label>Active</label>
    <div class="toggle-wrapper">
      <input type="checkbox" class="toggle-input" id="bom-active-toggle" [(ngModel)]="formData.isActive">
      <label class="toggle-label" for="bom-active-toggle"></label>
    </div>
  </div>

  <!-- Components section -->
  <div class="lines-section">
    <div class="lines-header">
      <span class="lines-title">Components</span>
      <button class="btn btn-sm btn-outline-primary" type="button" (click)="addComponent()">
        <i class="bi bi-plus-lg me-1"></i>Add
      </button>
    </div>

    <div *ngIf="components.length === 0" class="lines-empty">
      No components yet. Tap "Add" to begin.
    </div>

    <div *ngFor="let comp of components; let i = index" class="line-card" #lineCard>
      <div class="line-card-header">
        <span class="line-number">Component {{ i + 1 }}</span>
        <button class="line-delete-btn" type="button" (click)="removeComponent(i)" aria-label="Remove">
          <i class="bi bi-trash"></i>
        </button>
      </div>

      <div class="form-group-mobile">
        <label>Raw Material</label>
        <app-single-select-dropdown
          [options]="rawMaterialOptions"
          [selectedValue]="comp.rawMaterialItemID != null ? comp.rawMaterialItemID.toString() : null"
          placeholder="Select material"
          (selectedValueChange)="onRawMaterialSelectChange(comp, $event)">
        </app-single-select-dropdown>
      </div>

      <div class="form-row-2">
        <div class="form-group-mobile">
          <label>Quantity</label>
          <input type="number" class="form-control" [(ngModel)]="comp.quantityRequired" placeholder="0" min="0.01" step="0.01">
        </div>
        <div class="form-group-mobile">
          <label>UOM</label>
          <app-single-select-dropdown
            [options]="getUOMOptionsForItem(comp.rawMaterialItemID)"
            [selectedValue]="comp.componentUOMID != null ? comp.componentUOMID.toString() : null"
            [disabled]="!comp.rawMaterialItemID"
            [placeholder]="comp.rawMaterialItemID ? 'Select UOM' : 'Select material first'"
            (selectedValueChange)="comp.componentUOMID = $event != null ? +$event : null">
          </app-single-select-dropdown>
        </div>
      </div>
    </div>
  </div>

</app-offcanvas-sheet>
